import { ReactNode } from "react";

import cls from "./Modal.module.scss";
import { Overlay } from "../Overlay";
import { Portal } from "../Portal";
import { useModal } from "shared/lib/hooks/useModal/useModal";
import { classNames, Mods } from "shared/lib/classNames/classNames";

interface ModalProps {
    className?: string;
    children?: ReactNode;
    isOpen?: boolean;
    onClose?: () => void;
    lazy?: boolean;
    overlay?: boolean;
}

export const Modal = (props: ModalProps) => {
    const { className, children, isOpen, onClose, lazy, overlay = false } = props;

    const { close, isMounted } = useModal({
        animationDelay: 300,
        isOpen,
        onClose,
    });

    const mods: Mods = {
        [cls.opened]: isOpen,
    };

    if (lazy && !isMounted) {
        return null;
    }

    return (
        <Portal element={document.getElementById("app") ?? document.body}>
            <div className={classNames(cls.modal, mods, [])}>
                {overlay && <Overlay onClick={close} />}
                <div className={classNames(cls.content, {}, [className])}>{children}</div>
            </div>
        </Portal>
    );
};
